import { render, staticRenderFns } from "./AddOrEditTier.vue?vue&type=template&id=72c8df7e"
import script from "./AddOrEditTier.vue?vue&type=script&lang=js"
export * from "./AddOrEditTier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports